<stx-modal>
  <stx-notice [noticeType]="data.noticeType">
    @if (singleMessage) {
    {{ data.translatedMessages[0] }}
    } @else {
    <ul>
      @for (message of data.translatedMessages; track message) {
      <li>
        {{ message }}
      </li>
      }
    </ul>
    }
  </stx-notice>
</stx-modal>
